import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C4DAFF",
      d: "M14.233 9.043H7.96a.359.359 0 1 0 0 .717h6.272a.359.359 0 1 0 0-.717M14.233 12.122h-3.136a.359.359 0 1 0 0 .718h3.136a.359.359 0 1 0 0-.718M14.233 10.582H9.069a.359.359 0 1 0 0 .718h5.164a.359.359 0 1 0 0-.718"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#C4DAFF",
      d: "M16.744 0H3.333C2.64 0 2.077.563 2.077 1.256v3.942h-.822C.563 5.198 0 5.761 0 6.453v8.96c0 .691.563 1.254 1.255 1.254h13.412c.692 0 1.255-.563 1.255-1.255V11.47h.822c.693 0 1.256-.564 1.256-1.256V1.256C18 .564 17.437 0 16.744 0M2.794 2.598h14.489v.96H2.795zm.539-1.88h13.411c.297 0 .539.241.539.538v.624H2.795v-.624c0-.297.241-.538.538-.538M1.255 5.916h13.412c.297 0 .538.24.538.537v.984H.718v-.984c0-.296.24-.537.537-.537m13.95 9.497a.54.54 0 0 1-.538.536H1.255a.54.54 0 0 1-.537-.537V8.156h14.487zm1.54-4.66h-.823v-4.3c0-.692-.562-1.255-1.255-1.255H2.795v-.922h14.488v5.938a.54.54 0 0 1-.539.538"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#C4DAFF",
      d: "M4.444 8.916a2.877 2.877 0 0 0-2.873 2.874 2.877 2.877 0 0 0 2.873 2.874 2.877 2.877 0 0 0 2.873-2.874 2.877 2.877 0 0 0-2.873-2.874m0 5.03a2.16 2.16 0 0 1-2.156-2.156c0-1.189.968-2.156 2.156-2.156S6.6 10.601 6.6 11.79a2.16 2.16 0 0 1-2.156 2.156"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#C4DAFF",
      d: "M4.444 11.431a.274.274 0 1 1 .227-.426.36.36 0 0 0 .594-.402 1 1 0 0 0-.42-.345v-.133a.359.359 0 1 0-.717 0v.098a.989.989 0 0 0 .316 1.926.274.274 0 1 1-.227.426.36.36 0 0 0-.594.401c.123.183.302.31.505.379v.102a.359.359 0 1 0 .718 0v-.13a.99.99 0 0 0-.402-1.896"
    }, null, -1)
  ]))]))
}
export default { render: render }